import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import {
  Box,
  Container,
  Grid,
  Menu,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Custom3dotString from "../../../components/Custom3dotString";
import CustomButton from "../../../components/CustomButton";
import Checkbox from "../../../components/CustomCheckbox";
import CustomModal from "../../../components/CustomModal/CustomModal";
import CustomSwitch from "../../../components/CustomSwitch";
import CustomTextField from "../../../components/CustomTextField";
import { default as Select } from "../../../components/Select/Select";
import TopBar from "../../../components/TopBar/TopBar";
import {
  createClinicDoctors,
  createOthers,
  getClinicRoles,
} from "../../../redux/reducers/clinicSlice";
import { showSnackBar } from "../../../redux/reducers/snackSlice";
import {
  getClinicVets,
  updateVetBlockStatus,
} from "../../../redux/reducers/vetSlice";
import { AppColors } from "../../../util/AppColors";
import { ErrorStrings } from "../../../util/ErrorString";
import { EmailRegex } from "../../../util/Validations";
import { newRoleList } from "../../../util/arrayList";
import {
  clinicRolesList,
  salutationList,
  specialtyList,
  typeList,
} from "../../../util/dropList";
import { tblGrayBack } from "../../../util/object";
import generatePass from "../../../util/randomPassword";
import Department from "../ComingSoon/cards/Department";
import Schedule from "../ComingSoon/cards/Schedule";
import CommonPaymentUpdateModal from "../CommonPaymentUpdateModal/CommonPaymentUpdateModal";
import Main from "./VetCharts.js/Main";
import "./Vets.css";

const filterList = [
  { name: "All", value: "all" },
  { name: "Others", value: "other" },
  { name: "Vets", value: "doctor" },
];

const nameExpan = {
  salutation: "Salutation",
  name: "Name",
  speciality: "Speciality",
  conType: "Consultation Type",
  contactNumber: "Contact Number",
  email: "Email",
  password: "Password",
  role: "Role",
  access: "Access",
  calIcon: "",
  toggleIcon: "",
};

const initialValues = {
  salutation: null,
  name: "",
  speciality: null,
  contactNumber: "",
  conType: [],
  email: "",
  password: "",
  role: null,
  registrationNo: "",
  access: [],
  department: null,
};

const initialError = {
  salutation: false,
  name: false,
  speciality: false,
  conType: false,
  contactNumber: false,
  email: false,
  password: false,
  role: false,
  access: false,
};

const initialHelp = {
  salutation: "",
  name: "",
  speciality: "",
  conType: "",
  contactNumber: "",
  email: "",
  password: "",
  role: "",
  access: "",
};

const vetReqFlds = [
  "name",
  "role",
  // "access",
  "speciality",
  "conType",
  "email",
  "password",
];
const othersReqFlds = [
  "name",
  "role",
  //  "access",
  "email",
  "password",
];
const tblHeaders = [
  "name",
  "speciality",
  "role",
  "conType",
  "calIcon",
  "toggleIcon",
];

const Vets = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("content");
  const [conModVisible, setConModVisible] = useState(false);
  const [vetValues, setVetValues] = useState(initialValues);
  const [vetErrors, setVetErrors] = useState(initialError);
  const [vetHelps, setVetHelps] = useState(initialHelp);
  const [showPassword, setShowPassword] = useState(false);
  const [isAutoGenPass, setAutoGenPass] = useState(false);
  const [selectedVet, setSelectedVet] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [createModVisible, setCreateModalVisible] = useState(false);
  const [createUserType, setCreateUserType] = useState("Vet");
  const [vetFilter, setVetFilter] = useState("all");
  const [subTab, setSubTab] = useState(null);
  const [vetAnchorEl, setVetAnchorEl] = useState(null);
  // const [page, setPage] = useState(1);
  const vets = useSelector((state) => state?.vet?.vets);
  // const itemSize = 20;
  // const defaultUrl = `?type=all&itemSize=${itemSize}&page=1`;
  const defaultUrl = "?type=all";
  const clinicRoles = useSelector((state) => state?.clinic?.clinicRoles);

  useEffect(() => {
    dispatch(getClinicVets(defaultUrl));
    // dispatch(getGlobalDays());
  }, []);

  const getAllFilteredList = () => {
    return vets?.vets
      ?.filter((vet) => {
        return (vet?.name?.toLowerCase() || "")?.includes(
          searchValue?.toLowerCase()
        );
      })
      ?.map((li) => ({
        ...li,
        conType: li?.consulationType ? li?.consulationType?.join(", ") : "-",
        speciality: li?.speciality ? li?.speciality : "-",
      }));
  };

  const filteredVets = () => {
    return vets?.vets
      ?.filter((vet) => {
        const isVet = vet?.userType?.find(
          (usrTyp) => usrTyp?.name === "ROLE_DOCTOR"
        );
        return (
          isVet &&
          (vet?.name?.toLowerCase() ?? "")?.includes(searchValue?.toLowerCase())
        );
      })
      ?.map((li) => ({
        ...li,
        conType: li?.consulationType ? li?.consulationType?.join(", ") : "-",
        speciality: li?.speciality ? li?.speciality : "-",
      }));
  };

  const filteredOthers = () => {
    return vets?.vets
      ?.filter((vet) => {
        const otherUsers = vet?.userType?.find(
          (usrTyp) => usrTyp?.name !== "ROLE_DOCTOR"
        );
        return (
          otherUsers &&
          (vet?.name?.toLowerCase() ?? "")?.includes(searchValue?.toLowerCase())
        );
      })
      ?.map((li) => ({
        ...li,
        conType: li?.consulationType ? li?.consulationType?.join(", ") : "-",
        speciality: li?.speciality ? li?.speciality : "-",
      }));
  };

  const conModalOpen = () => {
    setConModVisible(!conModVisible);
  };

  const emailValidation = (value) => {
    if (value === "") {
      setVetErrors({ ...vetErrors, email: true });
      setVetHelps({ ...vetHelps, email: ErrorStrings.emptyEmail });
    }
    if (value !== "") {
      if (!EmailRegex.test(value)) {
        setVetErrors({ ...vetErrors, email: true });
        setVetHelps({ ...vetHelps, email: ErrorStrings.inValidEmail });
      } else {
        setVetErrors({ ...vetErrors, email: false });
        setVetHelps({ ...vetHelps, email: "" });
      }
    }
  };

  const passValidation = (value) => {
    if (value === "") {
      setVetErrors({ ...vetErrors, password: true });
      setVetHelps({ ...vetHelps, password: ErrorStrings.emptyPass });
      return;
    }
    if (value?.length < 6) {
      setVetErrors({ ...vetErrors, password: true });
      setVetHelps({ ...vetHelps, password: ErrorStrings.inValidPass });
      return;
    }
    setVetErrors({ ...vetErrors, password: false });
    setVetHelps({ ...vetHelps, password: "" });
  };

  const mobileValidation = (value) => {
    if (value === "") {
      setVetErrors({ ...vetErrors, contactNumber: true });
      setVetHelps({ ...vetHelps, contactNumber: ErrorStrings.emptyMobile });
      return;
    }
    if (value.length < 10 || value.length > 10) {
      setVetErrors({ ...vetErrors, contactNumber: true });
      setVetHelps({ ...vetHelps, contactNumber: ErrorStrings.inValidMobile });
      return;
    }
    setVetErrors({ ...vetErrors, contactNumber: false });
    setVetHelps({ ...vetHelps, contactNumber: "" });
  };

  const handleChange = (e) => {
    setVetValues({ ...vetValues, [e.target.name]: e.target.value });
    if (e.target.name === "email") return emailValidation(e.target.value);
    if (e.target.name === "password") return passValidation(e.target.value);
    if (e.target.name === "contactNumber") {
      return mobileValidation(e.target.value);
    }
    const { name, value } = e.target;
    if (vetErrors[name]) {
      setVetErrors({ ...vetErrors, [name]: false });
      setVetHelps({ ...vetHelps, [name]: "" });
    }

    setVetValues({
      ...vetValues,
      [name]:
        name === "name"
          ? value?.charAt(0).toUpperCase() + value?.slice(1)
          : value,
    });

    if (e.target.value === "") {
      setVetErrors({ ...vetErrors, [e.target.name]: true });
      setVetHelps({
        ...vetHelps,
        [e.target.name]: `${nameExpan?.[e.target.name]} Required Field`,
      });
    }
    if (e.target.value !== "") {
      setVetErrors({ ...vetErrors, [e.target.name]: false });
      setVetHelps({ ...vetHelps, [e.target.name]: "" });
    }
  };

  const handleMultiSelect = (event, name) => {
    const {
      target: { value },
    } = event;
    const reqValue =
      name === "access"
        ? value?.includes("Admin")
          ? ["Admin"]
          : value
        : value;
    setVetValues({
      ...vetValues,
      [name]: reqValue,
    });
    setVetErrors({
      ...vetErrors,
      [name]: reqValue?.length > 0 ? false : true,
    });
    setVetHelps({
      ...vetHelps,
      [name]: reqValue?.length > 0 ? "" : `${nameExpan?.[name]} Required Field`,
    });
  };

  const handleSelect = (value, key) => {
    if (vetErrors[key]) {
      setVetErrors({ ...vetErrors, [key]: false });
      setVetHelps({ ...vetHelps, [key]: "" });
    }
    setVetValues({ ...vetValues, [key]: value });
  };

  const handleChangeSwitch = async (e, vet) => {
    dispatch(
      updateVetBlockStatus({
        vetId: vet?.doctorId,
        active: e.target.value ? "Y" : "N",
      })
    ).then((res) => {
      if (res?.payload) {
        dispatch(getClinicVets(`?type=${vetFilter}`));
      }
    });
  };

  const checkRoleDoctor = (vet) => {
    const roleDoctor = vet?.userType?.find(
      (usr) => usr?.name === "ROLE_DOCTOR"
    );
    return roleDoctor ? true : false;
  };

  const handleCardClick = (vet) => {
    // if (!checkRoleDoctor(vet)) return;
    navigate("/vet-calendar", { state: { vet } });
  };

  const handleUpdateFeeUpdateSuccess = async () => {
    setSelectedVet(null);
    setConModVisible(!conModVisible);
    dispatch(getClinicVets(`?type=${vetFilter}`));
  };

  const handleAutoGenPassword = () => {
    setAutoGenPass(!isAutoGenPass);
    if (!isAutoGenPass) {
      const pass = generatePass();
      setVetValues({ ...vetValues, password: pass });
    } else {
      setVetValues({ ...vetValues, password: "" });
    }
  };

  const onClickCalendar = (vet) => {
    // if (!checkRoleDoctor(vet)) return;
    navigate("/manage-availability", { state: { vetId: vet?.doctorId } });
  };

  const onClickDollar = (vet) => {
    // if (!checkRoleDoctor(vet)) return;
    setSelectedVet(vet);
    if (vet?.active === "Y") {
      setConModVisible(!conModVisible);
    }
  };

  const handleCreate = () => {
    dispatch(getClinicRoles());
    setCreateModalVisible(true);
  };

  const createModalOpen = () => {
    setCreateUserType("Vet");
    setCreateModalVisible(!createModVisible);
    setVetValues(initialValues);
    setVetErrors(initialError);
    setVetHelps(initialHelp);
  };

  const handleChangeUserType = (e) => {
    setCreateUserType(e.target.value);
    setVetValues(initialValues);
    setVetErrors(initialError);
    setVetHelps(initialHelp);
  };

  const resetValues = () => {
    setVetValues(initialValues);
    setVetErrors(initialError);
    setVetHelps(initialHelp);
  };

  const handleSuccess = () => {
    dispatch(
      showSnackBar({
        message: "Clinic Vet Registered",
        type: "success",
      })
    );
    setCreateModalVisible(false);
    resetValues();
    dispatch(getClinicVets(`?type=${vetFilter}`));
  };

  const createVet = () => {
    let errs = {};
    let helps = {};
    vetReqFlds?.forEach((fld) => {
      if (
        vetValues?.[fld] === null ||
        vetValues?.[fld] === "" ||
        (Array.isArray(vetValues?.[fld]) && vetValues?.[fld]?.length === 0) ||
        (fld === "password" && vetValues?.[fld]?.length < 6) ||
        (fld === "email" && !EmailRegex.test(vetValues?.[fld]))
      ) {
        errs = { ...errs, [fld]: true };
        helps = {
          ...helps,
          [fld]:
            fld === "email"
              ? vetValues?.[fld] === ""
                ? ErrorStrings.emptyEmail
                : !EmailRegex.test(vetValues?.[fld])
                ? ErrorStrings.inValidEmail
                : ""
              : fld === "password"
              ? vetValues?.[fld] === ""
                ? ErrorStrings.emptyPass
                : vetValues?.[fld]?.length < 6
                ? ErrorStrings.inValidPass
                : ""
              : `${nameExpan?.[fld]} Required Field`,
        };
      } else {
        errs = { ...errs, [fld]: false };
        helps = { ...helps, [fld]: "" };
      }
    });
    setVetErrors({ ...vetErrors, ...errs });
    setVetHelps({ ...vetHelps, ...helps });
    if (Object.keys(errs)?.some((val) => errs?.[val] === true)) return;
    // Proceed with vet creation if all validations pass
    const data = new FormData();
    data.append("name", vetValues?.name);
    // data.append("salutation", "Dr.");
    data.append("speciality", vetValues?.speciality?.value);
    data.append("role", vetValues?.role?.value);
    data.append("department", vetValues?.department?.value ?? null);
    data.append("email", vetValues?.email);
    data.append("password", vetValues?.password);
    data.append("consulationType", vetValues.conType);
    data.append("mobile", vetValues?.contactNumber);
    data.append(
      "access",
      vetValues?.role?.apiValue ?? "VET"
      // vetValues?.access?.map(
      //   (ac) => accessList.find(({ value }) => value === ac)?.apiValue
      // )
    );
    if (vetValues?.registrationNo !== "") {
      data.append("registrationNo", vetValues?.registrationNo ?? "");
    }
    dispatch(createClinicDoctors(data))
      .then((res) => {
        if (res?.payload?.status === 200) {
          if (res?.payload?.data?.status === 400) {
            dispatch(
              showSnackBar({
                message: res?.payload?.data?.message,
                type: "error",
              })
            );
          }
          if (res?.payload?.data?.status === 200) {
            if (
              res?.payload?.data?.message === "User profile created" ||
              res?.payload?.data?.message ===
                "Doctor profile created successfully"
            ) {
              handleSuccess();
            }
          }
        }
        if (res?.payload?.status === 500) {
          if (
            res?.payload?.response?.data?.error === "Internal Server Error" &&
            res?.payload?.response?.data?.message === "Authentication failed"
          ) {
            handleSuccess();
          }
        }
      })
      .catch((error) => {
        console.error("API call failed:", error);
      });
  };

  const createOther = () => {
    // Validate fields
    let errs = {};
    let helps = {};
    othersReqFlds?.forEach((fld) => {
      if (
        vetValues?.[fld] === null ||
        vetValues?.[fld] === "" ||
        (Array.isArray(vetValues?.[fld]) && vetValues?.[fld]?.length === 0) ||
        (fld === "password" && vetValues?.[fld]?.length < 6) ||
        (fld === "email" && !EmailRegex.test(vetValues?.[fld]))
      ) {
        errs = { ...errs, [fld]: true };
        helps = {
          ...helps,
          [fld]:
            fld === "email"
              ? vetValues?.[fld] === ""
                ? ErrorStrings.emptyEmail
                : !EmailRegex.test(vetValues?.[fld])
                ? ErrorStrings.inValidEmail
                : ""
              : fld === "password"
              ? vetValues?.[fld] === ""
                ? ErrorStrings.emptyPass
                : vetValues?.[fld]?.length < 6
                ? ErrorStrings.inValidPass
                : ""
              : `${nameExpan?.[fld]} Required Field`,
        };
      } else {
        errs = { ...errs, [fld]: false };
        helps = { ...helps, [fld]: "" };
      }
    });
    setVetErrors({ ...vetErrors, ...errs });
    setVetHelps({ ...vetHelps, ...helps });
    if (Object.keys(errs)?.some((val) => errs?.[val] === true)) return;

    // Proceed with vet creation if all validations pass
    const data = new FormData();
    data.append("name", vetValues?.name);
    data.append("role", vetValues?.role?.value);
    data.append("salutation", vetValues?.salutation?.value);
    data.append("registrationNo", vetValues?.registrationNo);
    data.append("department", vetValues?.department?.value ?? null);
    data.append("email", vetValues?.email);
    data.append("password", vetValues?.password);
    data.append("mobile", vetValues?.contactNumber);
    data.append(
      "access",
      vetValues?.role?.apiValue
      // vetValues?.access?.map(
      //   (ac) => accessList.find(({ value }) => value === ac)?.apiValue
      // )
    );

    dispatch(createOthers(data)).then((res) => {
      if (res?.payload?.data?.status === 200) {
        if (res?.payload?.data?.message === "User Registered Successfully") {
          dispatch(
            showSnackBar({
              message: res?.payload?.data?.message,
              type: "success",
            })
          );
          setCreateModalVisible(false);
          resetValues();
          dispatch(getClinicVets(`?type=${vetFilter}`));
        } else {
          dispatch(
            showSnackBar({
              message: res?.payload?.data?.message,
              type: "error",
            })
          );
        }
      }
    });
  };

  const getDepartments = () => {
    return clinicRoles
      ?.filter((li) => li?.type === "department")
      ?.map((li) => ({
        name: li?.roleName,
        value: li?.roleName,
      }));
  };

  const handleChangeMaster = (val) => {
    setSelectedTab("Master");
    setSubTab(val);
  };

  const handleChangeTab = (tab) => {
    setSelectedTab(tab);
    setSubTab(null);
  };

  return (
    <>
      <div className="flex-row-ali-cen" style={{ padding: "12px 24px" }}>
        <div className="ph10pv3" onClick={() => handleChangeTab("dashboard")}>
          <div
            className={`flex-center cursor ${
              selectedTab === "dashboard"
                ? "pet-det-sel-tab"
                : "pet-det-un-sel-tab"
            }`}
          >
            Dashboard
          </div>
        </div>
        <div className="ph10pv3" onClick={() => handleChangeTab("content")}>
          <div
            className={`flex-center cursor ${
              selectedTab === "content"
                ? "pet-det-sel-tab"
                : "pet-det-un-sel-tab"
            }`}
          >
            Content
          </div>
        </div>
        <div className="w10Per">
          <div
            onMouseEnter={(e) => {
              setVetAnchorEl(e.currentTarget);
            }}
            className={`flex-center cursor ${
              selectedTab === "Master"
                ? "pet-det-sel-tab"
                : "pet-det-un-sel-tab"
            }`}
          >
            Master <ArrowDropDownIcon fontSize="small" />
          </div>
        </div>
        <Menu
          anchorEl={vetAnchorEl}
          open={Boolean(vetAnchorEl)}
          onClose={() => setVetAnchorEl(null)}
          MenuListProps={{
            onMouseLeave: () => setVetAnchorEl(null),
          }}
        >
          <MenuItem
            onClick={() => {
              setSubTab("Department");
              setSelectedTab("Master");
              setVetAnchorEl(null);
            }}
          >
            Department
          </MenuItem>
          <MenuItem
            onClick={() => {
              setSubTab("Schedule");
              setSelectedTab("Master");
              setVetAnchorEl(null);
            }}
          >
            Schedule
          </MenuItem>
        </Menu>
      </div>
      {selectedTab === "dashboard" ? (
        <Box
          sx={{
            height: "calc(100vh - 120px)",
            overflow: "auto",
            padding: "20px",
          }}
        >
          <Main />
        </Box>
      ) : null}{" "}
      {selectedTab === "content" ? (
        <>
          <TopBar>
            <Container maxWidth="xl">
              <Toolbar variant="regular">
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <div className="flex-row">
                    <div className="top-row-cen-con w100Per">
                      <Grid item xs={12} sm={12} md={5} lg={5} xl={5}>
                        <CustomTextField
                          placeholder="Search"
                          name="name"
                          fullWidth
                          handleChange={(e) => setSearchValue(e.target.value)}
                          value={searchValue}
                          backgroundColor={AppColors.lightPink}
                        />
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        sm={2}
                        md={2}
                        lg={1}
                        xl={1}
                        className="ml20"
                      >
                        <CustomButton text="Create" onClick={handleCreate} />
                      </Grid>
                      <div className="top-row-right-con w15Per topBar-select">
                        <Select
                          list={filterList}
                          value={vetFilter}
                          handleChange={(e) => {
                            setVetFilter(e?.target?.value);
                            dispatch(
                              getClinicVets(`?type=${e?.target?.value}`)
                            );
                          }}
                          name="vet"
                          select
                        />
                      </div>
                    </div>
                  </div>
                </Grid>
              </Toolbar>
            </Container>
          </TopBar>

          <Box className="pb-40 ph20">
            <TableContainer sx={{ maxHeight: 450 }} className="mb20">
              <Table
                sx={{ minWidth: 200 }}
                aria-labelledby="tableTitle"
                stickyHeader
              >
                <TableHead>
                  <TableRow>
                    {tblHeaders?.map((hdr, i) => (
                      <TableCell
                        style={tblGrayBack}
                        className={`table-header-text`}
                      >
                        <div
                          style={{
                            width:
                              hdr === "name" ||
                              hdr === "role" ||
                              hdr === "conType"
                                ? 250
                                : hdr === "speciality"
                                ? 230
                                : 70,
                          }}
                        >
                          {nameExpan?.[hdr]}
                        </div>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {(vetFilter === "all"
                  ? getAllFilteredList()
                  : vetFilter === "doctor"
                  ? filteredVets()
                  : filteredOthers()
                )?.length === 0 && (
                  <TableRow>
                    <TableCell colSpan={12} className="text-align-center h100">
                      <div className="no-rec">No records available</div>
                    </TableCell>
                  </TableRow>
                )}
                <TableBody>
                  {(vetFilter === "all"
                    ? getAllFilteredList()
                    : vetFilter === "doctor"
                    ? filteredVets()
                    : filteredOthers()
                  )?.map((li, i) => {
                    return (
                      <TableRow>
                        {tblHeaders?.map((hdr, ind) => (
                          <TableCell key={ind + i + "tr"} component="th">
                            <div
                              style={{
                                width:
                                  hdr === "name" ||
                                  hdr === "role" ||
                                  hdr === "conType"
                                    ? 250
                                    : hdr === "speciality"
                                    ? 230
                                    : 70,
                              }}
                            >
                              {hdr === "name" ? (
                                <div onClick={() => handleCardClick(li)}>
                                  <Custom3dotString
                                    str={`${
                                      li?.userType?.find(
                                        (usr) => usr?.name === "ROLE_DOCTOR"
                                      )
                                        ? "Dr. "
                                        : `${
                                            li?.salutation
                                              ? `${li?.salutation}. `
                                              : ""
                                          }`
                                    }${li?.name}`}
                                    className="font-bold fs14 capitalize cursor blue-color underline"
                                    length={20}
                                  />
                                </div>
                              ) : hdr === "calIcon" ? (
                                <div
                                  className="cursor"
                                  onClick={() => onClickCalendar(li)}
                                >
                                  <CalendarMonthOutlinedIcon
                                    className="card-head-orange-color"
                                    sx={{ height: 30, width: 30 }}
                                  />
                                </div>
                              ) : hdr === "toggleIcon" ? (
                                <CustomSwitch
                                  value={li?.active === "Y" ? true : false}
                                  onChange={(e) => handleChangeSwitch(e, li)}
                                  greenToGray
                                />
                              ) : (
                                li?.[hdr]
                              )}
                            </div>
                          </TableCell>
                        ))}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      ) : null}
      {selectedTab === "Master" ? (
        <Box sx={{ padding: "20px" }}>
          {subTab === "Department" && <Department />}
          {subTab === "Schedule" && <Schedule />}
        </Box>
      ) : null}
      <CommonPaymentUpdateModal
        open={conModVisible}
        onClose={conModalOpen}
        onApiSuccess={handleUpdateFeeUpdateSuccess}
        vet={selectedVet}
      />
      <CustomModal
        open={createModVisible}
        onClose={createModalOpen}
        header="Create"
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={1} className="ph20 scroll-90vh">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="txt-mont fs14 fw-600 ">User Type</div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Checkbox
              radio
              onChange={handleChangeUserType}
              radios={[
                { label: "Vet", value: "Vet" },
                { label: "Other", value: "Other" },
              ]}
              defaultValue={createUserType}
            />
          </Grid>
          {createUserType === "Other" ? (
            <Grid item xs={4} sm={4} md={3} lg={3} xl={3}>
              <div className="mb20">
                <Select
                  list={salutationList}
                  value={vetValues?.salutation}
                  handleChange={(e, value) => handleSelect(value, "salutation")}
                  name="salutation"
                  label="Salutation *"
                  search
                  error={vetErrors?.salutation}
                  helperText={vetHelps?.salutation}
                />
              </div>
            </Grid>
          ) : null}
          <Grid
            item
            xs={createUserType === "Other" ? 8 : 6}
            sm={createUserType === "Other" ? 8 : 6}
            md={createUserType === "Other" ? 9 : 6}
            lg={createUserType === "Other" ? 9 : 6}
            xl={createUserType === "Other" ? 9 : 6}
          >
            <div className="mb20">
              <CustomTextField
                name="name"
                fullWidth
                required={true}
                label={"Name"}
                handleChange={handleChange}
                value={vetValues?.name}
                helperText={vetHelps?.name}
                error={vetErrors?.name}
              />
            </div>
          </Grid>
          {createUserType === "Other" || createUserType === "Vet" ? (
            <>
              <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <div className="mb10">
                  <Select
                    list={
                      createUserType === "Vet" ? newRoleList : clinicRolesList
                    }
                    value={vetValues?.role}
                    handleChange={(e, value) => handleSelect(value, "role")}
                    required
                    label="Role *"
                    search
                    error={vetErrors?.role}
                    helperText={vetHelps?.role}
                  />
                </div>
              </Grid>
              {/* <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                <div className="mb20">
                  <Select
                    list={
                      createUserType === "Vet" ? accessList : accessListOthers
                    }
                    value={vetValues?.access}
                    handleChange={(e) => handleMultiSelect(e, "access")}
                    label="Access *"
                    multiSelectTagCheck
                    error={vetErrors?.access}
                    helperText={vetHelps?.access}
                  />
                </div>
              </Grid> */}
            </>
          ) : null}
          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="mb10">
              <Select
                list={getDepartments()}
                value={vetValues?.department}
                handleChange={(e, value) => handleSelect(value, "department")}
                required
                label="Department"
                search
                error={vetErrors?.department}
                helperText={vetHelps?.department}
              />
            </div>
          </Grid>
          {createUserType === "Vet" ? (
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <Select
                  list={specialtyList}
                  value={vetValues?.speciality}
                  handleChange={(e, value) => handleSelect(value, "speciality")}
                  name="speciality"
                  label="Speciality *"
                  search
                  error={vetErrors?.speciality}
                  helperText={vetHelps?.speciality}
                />
              </div>
            </Grid>
          ) : null}
          {createUserType === "Vet" ? (
            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
              <div className="mb20">
                <Select
                  list={typeList}
                  value={vetValues?.conType}
                  handleChange={(e) => handleMultiSelect(e, "conType")}
                  label="Consultation Type *"
                  multiSelectTagCheck
                  error={vetErrors?.conType}
                  helperText={vetHelps?.conType}
                />
              </div>
            </Grid>
          ) : null}

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="mb20">
              <CustomTextField
                value={vetValues?.contactNumber}
                handleChange={(e) =>
                  handleSelect(e?.target?.value, "contactNumber")
                }
                name="contactNumber"
                label="Phone Number"
                error={vetErrors?.contactNumber}
                fullWidth
                helperText={vetHelps?.contactNumber}
              />
            </div>
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
            <div className="mb20">
              <CustomTextField
                value={vetValues?.registrationNo}
                label="Registration No."
                handleChange={(e) =>
                  handleSelect(e?.target?.value, "registrationNo")
                }
                fullWidth
              />
            </div>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="mb20">
              <CustomTextField
                name="email"
                fullWidth
                handleChange={handleChange}
                label="Email"
                required={true}
                value={vetValues?.email}
                helperText={vetHelps?.email}
                error={vetErrors?.email}
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <div className="mb20">
              <CustomTextField
                name="password"
                fullWidth
                handleChange={handleChange}
                value={vetValues?.password}
                helperText={vetHelps?.password}
                error={vetErrors?.password}
                label="Password"
                required={true}
                showPassword={showPassword}
                handleClickShowPassword={() => setShowPassword(!showPassword)}
                password
              />
            </div>
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Checkbox
              label="Auto-Generate Password"
              checked={isAutoGenPass}
              onChange={handleAutoGenPassword}
            />
          </Grid>
          <div className="flex1-end">
            <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
              <CustomButton
                text="Register"
                onClick={createUserType === "Vet" ? createVet : createOther}
              />
            </Grid>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default Vets;
